import { Link } from "react-router-dom";
import { typeCategories } from "@/mocks/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-fill text-lg text-accent-400"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">欲望的诱惑</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/80">
              专注影视内容资讯与深度解读，为热爱影像的你，汇聚集最新的剧情介绍、演员资料与专题合集。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-music-2-fill", "ri-movie-2-fill"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">影视分类</h4>
            <ul className="space-y-2.5">
              {typeCategories.map((c) => (
                <li key={c.key}>
                  <Link
                    href={`/category?type=${encodeURIComponent(c.key)}`}
                    to={`/category?type=${encodeURIComponent(c.key)}`}
                    className="text-sm text-background-200/80 hover:text-accent-400 transition-colors"
                  >
                    {c.key}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">网站导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: "首页", path: "/" },
                { label: "影视分类", path: "/category" },
                { label: "搜索影视", path: "/search" },
                { label: "关于我们", path: "/about" },
                { label: "联系我们", path: "/contact" },
              ].map((l) => (
                <li key={l.label}>
                  <Link
                    href={l.path}
                    to={l.path}
                    className="text-sm text-background-200/80 hover:text-accent-400 transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-3 text-sm text-background-200/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                <span>hello@yuwangdeyouhuo.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-accent-400"></i>
                <span>400-820-1234</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-accent-400 mt-0.5"></i>
                <span>上海市静安区影视创意园 A 座 12 层</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/60 text-center sm:text-left">
            © {year} 欲望的诱惑 · 本站为影视资讯展示站点，所有内容均为演示数据，不提供在线播放与下载服务。
          </p>
          <p className="text-xs text-background-200/60">
            内容仅供交流学习 · 图片为演示素材
          </p>
        </div>
      </div>
    </footer>
  );
}